import './styles.scss';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { usePayouts } from '../../../../store/payouts';
import DialogExportPayouts from './dialog';
import l from '../../../../lang';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/file-download.svg';
import { segmentTransactionsDownloadReport } from '../../../../utils/analytics';

const ExportPayouts = () => {
  const { showExportPayouts } = usePayouts();
  return (
    <>
      <DialogExportPayouts />
      <div className="export_transactions__top_button">
        <ButtonCustom
          text={<span className="export_transactions__top_button__text">{l('exportPayouts.open')}</span>}
          onClick={() => {
            segmentTransactionsDownloadReport();
            showExportPayouts(true);
          }}
          variant="outlined"
          startIcon={<DownloadIcon className="export_transactions__top_button__icon" />}
          fullWidth
        />
      </div>
    </>
  );
};

export default ExportPayouts;
